const domainProductMap: { [key: string]: AnimatronProduct } = {
    'localhost:3000': 'WAVE',
    'localhost:3005': 'WAVE',
    'wave-test.video': 'WAVE',
    'wave.video': 'WAVE',
    'animatron-test': 'STUDIO',
    'animatron': 'STUDIO'
};
export default (domain: string) =>
    Object.keys(domainProductMap)
        .filter(key => domain.includes(key))
        .map<AnimatronProduct>(key => domainProductMap[key])[0];



// WEBPACK FOOTER //
// ./app/assets/javascripts/helpers/getProductByDomain.ts